import { Injectable, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { PanelBarItemModel } from '@progress/kendo-angular-layout';
import { Usage } from '../../../shared/domain/tnt/Usage';
import { TntToolStateService } from './tnt-tool-state.service'
import { CgpConfirmationDialogService } from '../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { cgpAuthentication } from '../../../../modules/cgp-authentication';

import {
    CenterService,
    ProgramService,
    PlantService,
    PlantProgramService,
    ModelYearService,
    GlobalRegionService,
} from '../../mesc/mesc.service';
import { takeUntil } from 'rxjs/operators';
import { CgpSnackbarService } from 'src/app/shared/cgp-snackbar/cgp-snackbar.service';

@Injectable()
export class TntToolUsageComponent implements OnDestroy {

    private usageEditDataItem: Subject<any> = new BehaviorSubject<any>(null);
    private usagePanelBarItems: Subject<any[]> = new BehaviorSubject<any[]>(null);
    public programModelYear: Subject<string> = new BehaviorSubject<string>(undefined);

    private usageFormControls: Subject<any[]> = new BehaviorSubject<any[]>([]);

    private ngUnsubscribe: Subject<void> = new Subject<void>();

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    editDataItem: any;
    panelBarControlSelectedItem: any;
    isEditPanelBarItem: boolean;
    usages: any;
    // plantState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    constructor(
        private formBuilder: FormBuilder,
        public modelYearService: ModelYearService,
        private centerService: CenterService,
        private globalRegionService: GlobalRegionService,
        public programService: ProgramService,
        public plantService: PlantService,
        public plantProgramService: PlantProgramService,
        private toolEditDataItem: TntToolStateService,
        private cgpConfirmationDialogService: CgpConfirmationDialogService,
        private cgpSnackbarService: CgpSnackbarService
    ) {
        this.modelYearService.query();
        this.plantService.query();
        this.programService.read('', true);

        this.usageEditDataItem
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(item => this.usageFormDialog.editDataItem = item);

        this.usagePanelBarItems
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(usages => this.panelBarControl.items = usages);

        this.toolEditDataItem.state$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((state) => {
                this.editDataItem = state;
                if (state) this.usages = this.editDataItem.ToolUsages;
                this.updateUsagePanelBarItems(state);
            });

        this.programService
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
                try {
                    data.map(x => x.Description = x.ProgramModelYear + '-' + x.ProgramCode + ' ' + x.ProgramDescription)
                } catch (e) { }
            });

        this.plantProgramService
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
                let plants: any[] = this.plantService.value.filter(x => data.some(pp => pp.PlantId === x.Id));
            });


        this.usageFormControls.subscribe(x => this.usageFormControl.formControls = x);
        this.toolEditDataItem.get();

        this.cgpSnackbarService.showSnackbar({
          message: "As of 10/20/2023 the Excel Export feature is restored",
          duration: 5000
        });

    }

    updateUsageForm = (isNew, dataItem: any = undefined) => {
        let isShowPanelBar: boolean;
        isShowPanelBar = !isNew &&
            this.editDataItem &&
            !this.isEditPanelBarItem;
        let status = this.editForm.get('IsActive');

        // If new Tool
        if (isNew || !dataItem) {
            this.editForm.removeControl('Id');
            status.setValue(true);
            this.editForm.get("Quantity").setValue(1);

            if (this.editDataItem && this.editDataItem.Id) {
                this.editForm.addControl('TntToolId', new FormControl());
                this.editForm.get('TntToolId').setValue(this.editDataItem.Id);
            } else {
                this.editForm.removeControl('TntToolId');
            }

            // Editing existing Tool
        } else {
            if (this.isEditPanelBarItem) {
                this.editForm.addControl('Id', new FormControl());
                this.editForm.addControl('TntToolId', new FormControl());
            }
            this.editForm.reset(dataItem);
        }

        this.usageFormControls.next(isShowPanelBar ? [this.panelBarControl] : this.formControls);
    }


    getModelYearByProgramId(ProgramId: string) {
        let program = this.programService.value
            .find(item => item.Id === ProgramId);
        let modelYear = this.modelYearService.value
            .find(item => item.Id === program.ModelYearId);
        return modelYear;
    }


    updateUsageEditDataItem = (dataItem: any = undefined) => {
        if (dataItem && dataItem.id) {
            let index = parseInt(dataItem.id);
            let usage = this.editDataItem.ToolUsages[index];
            this.usageEditDataItem.next(usage);

            let modelYear = this.getModelYearByProgramId(usage.ProgramId);
            this.programModelYear.next(modelYear.Year);
        } else {
            let usage: Usage = new Usage();
            this.usageEditDataItem.next(usage);
            this.programModelYear.next(undefined);
        }
    }


    removeUsage = (dataItem: any = undefined): void => {
        let index = parseInt(dataItem.id);
        this.editDataItem.ToolUsages.splice(index, 1);
        this.toolEditDataItem.set(this.editDataItem);
        this.usageEditDataItem.next(undefined);
    }


    filterNameById(checkVal, itemList, nameField, valueField: string = 'Id'): any {
        try {
            return itemList.find(item => {
                return item[valueField] === checkVal;
            })[nameField];
        } catch (e) {
            return "";
        }
    }


    updateUsagePanelBarItems = (dataItem: any): void => {
        let items: any[] = [];
        if (dataItem && dataItem.ToolUsages) {
            if (dataItem.ToolUsages.length === 1) {
                this.panelBarControl.editTemplate.delete = false;
            }
            else {
                this.panelBarControl.editTemplate.delete = true;
            }
            items = dataItem.ToolUsages.map((usage, index) => <PanelBarItemModel>{
                id: index.toString(),
                title: "",
                expanded: true,
                content: [
                    {
                        title: "Region",
                        value: this.filterNameById(usage.GlobalRegionId, this.globalRegionService.value, 'Description')
                    },
                    {
                        title: "Status",
                        value: usage.IsActive ? "Active" : "Inactive"
                    },
                    {
                        title: "Program",
                        value: this.filterNameById(usage.ProgramId,
                            this.programService.value, 'Description')
                    },
                    {
                        title: "Quantity",
                        value: usage.Quantity
                    },
                    {
                        title: "Plant",
                        value: this.filterNameById(usage.PlantId,
                            this.plantService.value, 'PlantDescription')
                    },
                    {
                        title: "Usage Owner",
                        value: usage.UsageOwner
                    },
                    {
                        title: "Model Year",
                        value: this.filterNameById(usage.ModelYearId,
                            this.modelYearService.value, 'Year')
                    },
                    {
                        title: "Station/Area",
                        value: usage.Station
                    },
                    {
                        title: "Design Source",
                        value: usage.DesignSource
                    },
                    {
                        title: "Build Source",
                        value: usage.BuildSource
                    },
                    {
                        title: "Description",
                        value: usage.ToolUsageDescription
                    },
                ]
            })
        }
        items.map(item => item.title =
            item.content[0].value + ', ' +
            item.content[2].value + ', ' +
            item.content[4].value + ', ' +
            item.content[6].value);
        this.usagePanelBarItems.next(items);
    }

    handleRegionChange = (id: string) => {
        let programCtrl = this.editForm.get('ProgramId');
        programCtrl.setValue(undefined);
        programCtrl.markAsTouched();
        programCtrl.disable();
        this.handleProgramChange(undefined);

        if (id) {
            this.editForm.get('GlobalRegionId').setValue(id);

            let filterParam: string = '?$filter=GlobalRegionId eq ' + id;
            filterParam += ' and IsActive eq true';
            let orderByParam: string = '&$orderby=ProgramModelYear desc';
            let queryString = filterParam + orderByParam;
            this.programService.read(queryString, true);

            this.editForm.get('ProgramId').enable();
        } else {
            this.programService.reset();
        }
    }

    handleProgramChange = (id: string) => {
        let modelYrCtrl = this.editForm.get("ModelYearId"),
            plantCtrl = this.editForm.get('PlantId');
        modelYrCtrl.markAsTouched();
        plantCtrl.markAsTouched();
        plantCtrl.setValue(undefined);
        plantCtrl.disable();
        modelYrCtrl.setValue(undefined);
        modelYrCtrl.disable();
        this.programModelYear.next(undefined);

        if (id) {
            this.cascade(id, this.plantProgramService, 'ProgramId');
            plantCtrl.enable();
            let modelYear = this.getModelYearByProgramId(id);
            if (!modelYear) return;
            modelYrCtrl.enable();
            modelYrCtrl.setValue(modelYear.Id);
            this.programModelYear.next(modelYear.Year);
        } else {
            this.plantProgramService.reset();
        }

    }

    cascade = (id: string, service: any, field: string, orderBy: any = null) => {
        let filterParam: string = '?$filter=' + field + ' eq ' + id;
        let orderByParam: string = orderBy ? '&$orderby=' + orderBy.field + ' ' + orderBy.order : '';
        let queryString = filterParam + orderByParam;

        service.query(queryString);
    }


    panelBarControlstateChange = (dataItems: any[]) => {
        this.panelBarControlSelectedItem = dataItems.find(item => item.selected);
    }


    onPanelBarItemDelete(control, dataItem) {
        var self = this;
        this.cgpConfirmationDialogService.showConfirmationDialog({
            title: 'Delete Confirmation',
            message: 'Are you sure that you want to delete this record?',
            alert: 'danger',
            onYesClick: () => {
                this.handleUsageDelete(dataItem);
                this.cgpConfirmationDialogService.closeConfirmationDialog();
            },
            onNoClick: () => {
                this.cgpConfirmationDialogService.closeConfirmationDialog();
            }
        });
    }


    onPanelBarItemEdit = (dataItem, isNew) => {
        this.handleRegionChange(this.editDataItem.GlobalRegionId);
        this.isEditPanelBarItem = true;

        if (dataItem) {
            try {
                if (dataItem) {
                    let usages = this.editDataItem['ToolUsages'];
                    dataItem = usages[dataItem.id]
                }
            } catch (e) { }
            this.handleProgramChange(dataItem.ProgramId);

            this.updateUsageForm(isNew, dataItem);
        } else {
            this.updateUsageForm(isNew);
        }
    }


    resetForm() {
        this.editForm.get('PlantId').disable();
        this.editForm.get('ProgramId').disable();
        this.editForm.get('ModelYearId').disable();
        this.editForm.reset({});
        this.isEditPanelBarItem = false;
        this.panelBarControlSelectedItem = undefined;

    }

    isShowUsageControls = (): boolean => {
        return true;
    }

    isButtonDisabled = (button): boolean => {
        return button.id === 'save' ?
            !this.editForm.valid :
            button === 'delete' ?
                this.editDataItem.ToolUsages.length <= 1 :
                false;
    }

    handleUsageCancel = () => {
        this.resetForm();
        this.updateUsageForm(false);
    }

    handleUsageSave = () => {
        this.usages = this.editDataItem.ToolUsages;
        let editUsage = this.editForm.value;
        let userInfo = cgpAuthentication.getUserInfo();
        if (editUsage.Id) {
            let index = this.usages.findIndex(x => x.Id === editUsage.Id);
            editUsage.CreatedBy = parseInt(userInfo.gmuniqueidentifier || userInfo.gmin);
            if (index > -1) this.usages[index] = editUsage;
        } else {
            editUsage.UsageOwner = userInfo.cn;
            editUsage.CreatedBy = parseInt(userInfo.gmuniqueidentifier || userInfo.gmin);
            this.usages.push(editUsage);
            this.editDataItem.ToolUsages = this.usages;
        }

        this.toolEditDataItem.set(this.editDataItem);
        this.resetForm();
        this.updateUsageForm(false);
    }

    handleUsageDelete = (dataItem) => {
        this.usages = this.editDataItem.ToolUsages;
        if (this.usages && this.usages.length > 1 && dataItem.id) {
            try {
                let index = parseInt(dataItem.id);
                if (index > -1) this.usages.splice(index, 1);
                this.editDataItem.ToolUsages = this.usages;
            } catch (e) { }
        }
        this.toolEditDataItem.set(this.editDataItem);
        this.resetForm();
        this.updateUsageForm(false);
    }


    editForm: UntypedFormGroup = this.formBuilder.group({
        GlobalRegionId: [''],
        PlantId: ['', Validators.required],
        ProgramId: ['', Validators.required],
        ModelYearId: ['', Validators.required],
        Station: [''],
        DesignSource: [''],
        BuildSource: [''],
        UsageOwner: [''],
        ToolUsageDescription: [''],
        IsActive: [true],
        Quantity: [1],
    });


    panelBarControl = {
        type: 'panelBarView',
        name: 'ToolUsages',
        expandMode: 'multiple',
        height: '320',
        selectable: true,
        items: undefined,
        editTemplate: {
            isDisabled: this.isButtonDisabled,
            addButton: {
                iconClass: "fa fa-plus fa-fw",
                isPrimary: true,
                title: "Add new usage",
            },
            delete: true,
            edit: true
            // formDialog: this.usageFormDialog,
        }
    };

    formControls = [
        {
            type: "combobox",
            name: "ProgramId",
            title: "Program",
            placeholder: "Select a program...",
            textField: "Description",
            valueField: "Id",
            onChange: this.handleProgramChange,
            service: this.programService,
        },
        {
            type: "buttongroup",
            show: this.isShowUsageControls,
            buttons: [
                {
                    primary: false,
                    id: 'cancel',
                    title: '',
                    iconClass: 'fa fa-ban',
                    isDisabled: this.isButtonDisabled,
                    callback: this.handleUsageCancel,
                },
                {
                    primary: true,
                    id: 'save',
                    title: '',
                    iconClass: 'fa fa-floppy-o',
                    isDisabled: this.isButtonDisabled,
                    callback: this.handleUsageSave,
                },
            ]
        },
        {
            type: "combobox",
            name: "PlantId",
            title: "Plant",
            placeholder: "Select a plant...",
            textField: "PlantDescription",
            valueField: "Id",
            service: this.plantService,
        },
        {
            type: "combobox",
            name: "ModelYearId",
            title: "Model Year",
            placeholder: "Select a Model Year...",
            textField: "Year",
            valueField: "Id",
            service: this.modelYearService,
        },
        {
            type: "number",
            name: "Quantity",
            title: "Quantity",
            placeholder: "Select a quantity...",
            minimum: '1',
            maximum: '9999',
        },
        {
            type: "boolean",
            name: "IsActive",
            title: "Active",
        },
        {
            type: 'text',
            name: 'ToolUsageDescription',
            title: 'Description',
        },
        {
            type: "text",
            name: "Station",
            title: "Station",
            maxlength: 40,
        },
        {
            type: "text",
            name: "DesignSource",
            title: "Design Source",
            maxlength: 40,
        },
        {
            type: "text",
            name: "BuildSource",
            title: "Build Source",
            maxlength: 40,
        }
    ];

    usageFormDialog = {
        title: "Tool Usage",
        editForm: this.editForm,
        editDataItem: undefined,
        edit: this.updateUsageEditDataItem,
        delete: this.removeUsage,
        tabs: [
            {
                title: "",
                columnClass: 'flex-wrap-column col-size-2',
                selected: true,
                formControls: this.usageFormControls
            },
        ]
    }

    usageFormControl = {
        editForm: this.editForm,
        title: "Usage",
        style: 'right',
        selected: false,
        formControls: this.formControls
    }

}
